import React from 'react';
import { Button } from '@material-ui/core';
import { CONTACT_TYPE } from './AddContactV3';
import { drawerHeaderStyle } from './AddContactV2Style';

const imgSrc = `${process.env.REACT_APP_CDN_LINK}assets/images/releases/smart_list/1.0.0/smart_lists_icon.png`;



const DrawerHeader = ({ contactType, setContactType }) => {
    const classes = drawerHeaderStyle();
    
    return (
        <div className={classes.headerWrapper}>
            <div>
                <div className={classes.titleContainer}>
                <div className={classes.logoContainer}>
                    <img height={50} width={50} src={imgSrc} alt="logo" className={classes.logo} />
                </div> 
                <h2 className={classes.drawerTitle} style={{ color: "#000" }}>New Contact</h2>
                </div>
            </div>

            <div style={{ display: "flex", gap: "8px" }}>
                <Button
                    variant={contactType === CONTACT_TYPE.PERSONAL ? "contained" : "outlined"}
                    color={contactType === CONTACT_TYPE.PERSONAL ? "primary" : ""} 
                    size='small'
                    disableElevation
                    onClick={() => setContactType(CONTACT_TYPE.PERSONAL)}
                    className={classes.headerButton}
                >
                    Personal
                </Button>
                <Button
                    variant={contactType === CONTACT_TYPE.COMMERCIAL ? "contained" : "outlined"}
                    color={contactType === CONTACT_TYPE.COMMERCIAL ? "primary" : ""} 
                    size='small'
                    disableElevation
                    onClick={() => setContactType(CONTACT_TYPE.COMMERCIAL)}
                    className={classes.headerButton}
                >
                    Commercial
                </Button>
            </div>
        </div>
    );
};

export default DrawerHeader;